import { useListsStore } from '@stores/lists'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

export const useTimeSlotsApi = async (): Promise<string[]> => {
  const { $axios } = useNuxtApp()
  const url = useCsRoutes('configurations.time-slots')

  const listsStore = useListsStore()

  try {
    listsStore.setTimeSlotsLoading(true)
    const { data } = await $axios.get(url!)

    const timeSlots = data?.data?.time_slots || null
    listsStore.setTimeSlots(timeSlots)
    return timeSlots
  } finally {
    listsStore.setTimeSlotsLoading(false)
  }
}
